import type { ReactNode } from 'react';
import { useFeedbackUrl } from '@/hook/useFeedbackUrl';

interface FeedbackLinkProps {
  className?: string;
  children: ReactNode;
}

/** A link to the feedback form in a new tab, carrying the build and the
 * handle, or nothing on a deployment that names no form. The caller styles it. */
export function FeedbackLink({ className, children }: FeedbackLinkProps) {
  const href = useFeedbackUrl();
  if (!href) return null;
  return (
    <a href={href} target="_blank" rel="noreferrer" className={className}>
      {children}
    </a>
  );
}
